import { Component } from "react"
import PropTypes from "prop-types"
import { startsWith, endsWith } from "lodash"
import classNames from "classnames"
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material"

class PositionsTableHeader extends Component {
  static propTypes = {
    index: PropTypes.any.isRequired,
    positionsSorting: PropTypes.object.isRequired,
    setPositionsSorting: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
  }

  setPositionsSorting = () => {
    const { setPositionsSorting, index } = this.props
    setPositionsSorting(index)
  }

  render() {
    const { positionsSorting, index, label } = this.props
    return <div className={classNames("column-header", { selected: positionsSorting.by === index })} onClick={this.setPositionsSorting}>
      <div className="column-label" title={label}>{label}</div>
      {positionsSorting.by === index && startsWith(positionsSorting.order, "asc") && <ArrowDropUp className={classNames({ absolute: endsWith(positionsSorting.order, "Abs") })} />}
      {positionsSorting.by === index && startsWith(positionsSorting.order, "desc") && <ArrowDropDown className={classNames({ absolute: endsWith(positionsSorting.order, "Abs") })} />}
    </div>
  }
}

export default PositionsTableHeader
